module.exports = __webpack_public_path__ + "img/truck-monster.21dadaca.svg";